import CircularProgress, {
    circularProgressClasses,
  } from '@mui/material/CircularProgress';
import React from "react";

const CircleSpinner = ({isBlue}) => {
  return (
    <>
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: isBlue? 'primary' : 'white',
          animationDuration: "550ms",
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={25}
        thickness={5}
      />
    </>
  );
};

export default CircleSpinner;
